import type { WorkDayDto } from '../../../api/generated/v2/generated/data-contracts';

export const isWorkDay = (workWeek: WorkDayDto[]) => {
    const enabledDays = new Set(
        workWeek
            .filter(day => day.isWorkingDay)
            .map(day => day.dayOfWeek?.toLowerCase())
            .filter((name): name is string => !!name),
    );

    return (dateStr: string): boolean => {
        const d = new Date(dateStr + 'T12:00:00Z');
        const weekday = d.toLocaleDateString('en-US', { weekday: 'long', timeZone: 'UTC' }).toLowerCase();
        return enabledDays.has(weekday);
    };
};
